import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  useToast,
} from '@chakra-ui/react';
import { deleteUser } from '../api/auth';
import { getApiErrorMessage } from '../utils/apiError';

const DeleteUserModal = ({ isOpen, onClose, userId, refetch }) => {
  const toast = useToast();

  const handleDelete = async () => {
    try {
      await deleteUser(userId);
      toast({
        title: 'User Deleted',
        description: 'User has been successfully deleted.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      refetch(); // Kullanıcı listesini güncelle
      onClose();
    } catch (error) {
      console.error('Error deleting user:', error);
      toast({
        title: 'Error',
        description: getApiErrorMessage(error, 'Failed to delete user.'),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete User</ModalHeader>
        <ModalBody>
          <Text>Are you sure you want to delete this user?</Text>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="red" mr={3} onClick={handleDelete}>
            Delete
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteUserModal;
